<template>

	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
	
	
</template>

<script>
export default {
name: 'app',

	

}

</script>

<style lang="scss">
body {
	margin: 0px;
	padding: 0px;
	//background: url(assets/53.jpg);
	height: 100%;
	position:fixed;
	width: 100%;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	background-repeat: no-repeat;
	background-size: cover;
   
}

#app {
	top: 0px;
	bottom: 0px;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #fff;
	padding: 10px;
	//border:1px solid #fff;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 100px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

</style>


// WEBPACK FOOTER //
// App.vue?50becb5a